import { ReturnButtonWrapper } from './ReturnButton.css';

type ReturnButtonProps = {
  handleReturnClick: () => void;
};

export default function MintButton({ handleReturnClick }: ReturnButtonProps) {
  return <ReturnButtonWrapper onClick={handleReturnClick}>TRY AGAIN</ReturnButtonWrapper>;
}
